import { ChipButton } from "./Button"

type Props = {
  options: { label: string; value: string; disabled?: boolean }[]
  value: string[]
  onValueChange: (value: string[]) => void
  unwrapped?: boolean
}

export function ChipGroup(props: Props) {
  const contents = props.options.map((option) => (
    <ChipButton
      key={option.value}
      active={props.value.includes(option.value)}
      disabled={option.disabled}
      variant={"outline"}
      onClick={() => {
        if (props.value.includes(option.value)) {
          props.onValueChange(props.value.filter((value) => value !== option.value))
        } else {
          props.onValueChange([...props.value, option.value])
        }
      }}
    >
      {option.label}
    </ChipButton>
  ))

  if (props.unwrapped) {
    return <>{contents}</>
  } else {
    return <div className="flex flex-wrap gap-1">{contents}</div>
  }
}
